import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Text } from "@chakra-ui/react";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ContactUs = () => {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [showFormError, setShowFormError] = useState(false);

  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const validate = () => {
    const el = form.current;
    if (!el) return false;
    const data = new FormData(el);
    const name = String(data.get("user_name") ?? "").trim();
    const email = String(data.get("user_email") ?? "").trim();
    const message = String(data.get("message") ?? "").trim();
    return (
      Boolean(name && email && message) && emailPattern.test(email)
    );
  };

  const clearFormError = () => setShowFormError(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSent(false);

    if (!validate()) {
      setShowFormError(true);
      return;
    }
    setShowFormError(false);

    if (!serviceId || !templateId || !publicKey) {
      console.log(
        "FAILED... Missing EmailJS env vars (REACT_APP_EMAILJS_SERVICE_ID / REACT_APP_EMAILJS_TEMPLATE_ID / REACT_APP_EMAILJS_PUBLIC_KEY)."
      );
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, form.current, {
        publicKey,
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setSent(true);
          setShowFormError(false);
          form.current?.reset();
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <div className="form">
      <Text
        fontSize={["26px", "32", "38px"]}
        fontFamily={"Title"}
        color={"lightBlue"}
        mb={10}
      >
        LET'S GET IN TOUCH!
      </Text>

      <form ref={form} onSubmit={sendEmail} noValidate>
        <div className="login">
          <input
            id="contact-name"
            type="text"
            name="user_name"
            placeholder="Enter your name"
            autoComplete="name"
            onChange={clearFormError}
          />
          <input
            id="contact-email"
            type="email"
            name="user_email"
            placeholder="Enter your Email"
            autoComplete="email"
            inputMode="email"
            onChange={clearFormError}
          />
        </div>

        <div className="text-aria">
          <textarea
            id="contact-message"
            name="message"
            placeholder="Type your message here..."
            onChange={clearFormError}
          />

          {showFormError ? (
            <span className="form-validation-note" role="alert">
              Please fill out all fields.
            </span>
          ) : null}

          <input className="submit" type="submit" value="Send" />
          {sent ? (
            <Text mt={3} color="lightBlue" fontSize="14px" textAlign="center">
              Message sent!
            </Text>
          ) : null}
        </div>
      </form>

      {/* <SocialMediaLinks /> */}
      <Text my={10} fontSize={["10px","14px"]}
          align={"center"}
          color={"lightBlue"}>Copyright © 2026 Negin Alphi. All Rights Reserved.</Text>

    </div>
  );
};
